import { IRootState } from 'app/shared/reducers';
import { isMobileDevice } from 'app/shared/util/methode-util';
import React from 'react';
import { useSelector } from 'react-redux';
import DesktopNoMatchedAdhesion from '../../desktop/desktop-no-matched-adhesion';
import MobileNoMatchedAdhesion from '../../mobile/mobile-no-matched-adhesion';

const NoMatchedAdhesion = props => {
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const configuration: any = useSelector<IRootState>(state => state.global.configuration);
  const params = { ...props, avatar };
  return (
    <>
      {isMobileDevice(configuration) ?
        <MobileNoMatchedAdhesion {...params} />
        :
        <DesktopNoMatchedAdhesion {...params} />
      }
    </>
  );
};

export default NoMatchedAdhesion;
